<template>
    <div class="containeraa">
      <div class="left1-container">
        <div class="header">
        <h1>设备信息</h1>
        <!-- <p>展示中央、自治区、盟市、旗县区等各级财政资金分布情况</p>     -->
      </div>
      
      <div class="chart-container">
        <div class="chart-wrapper">
          <div ref="chart" style="width: 100%; height: 100%;"></div>
        </div>
      </div>
      </div>

      <div class="right1-container">
        <Bottom1/>
      </div>
      
      
      <!-- <div class="data-info">
        <div class="data-item" v-for="(item, index) in data" :key="index">
          <div class="color-indicator" :style="{background: colors[index]}"></div>
          {{ item.name }}: {{ item.value }}亿元
        </div>
      </div> -->
      
      <!-- <div class="controls">
        <button class="control-btn" @click="updateData">更新数据</button>
        <button class="control-btn" @click="resetData">重置数据</button>
        <button class="control-btn" @click="toggleLegend">{{ showLegend ? '隐藏图例' : '显示图例' }}</button>
      </div> -->
    </div>
  </template>
  
  <script>
  // 注意：在Vue项目中需要先安装echarts: npm install echarts
import * as echarts from 'echarts'
import Bottom1 from '../Bottom1/index.vue'
import { left1Data } from '@/api/ksharge'

  export default {
    name: 'FundDistributionChart',
    components: {
      Bottom1
    },
    data() {
      return {
        fontColor: '#fff',
        data: [
          // { name: "在线设备", value: 456 },
          // { name: "离线设备", value: 231 },
        //   { name: "旗县区", value: 45 },
        //   { name: "整合资金", value: 154 },
        //   { name: "其他", value: 67 }
        ],
        colors: ['#bf19ff', '#854cff', '#5f45ff', '#02cdff', '#314976', '#f9e264', '#f47a75', '#009db2', '#024b51', '#765005'],
        myChart: null,
        showLegend: true,
        totalValue: 0
      }
    },
    computed: {
      chartOption() {
        // 计算总计
        this.totalValue = this.data.reduce((sum, item) => sum + item.value, 0)
        
        return {
          color: this.colors,
          backgroundColor: 'transparent',
          title: {
            text: this.totalValue.toString(),
            subtext: '设备数量',
            left: '45%',
            top: '50%',
            textAlign: 'center',
            // 设备数量数字模块
            textStyle: {
              color: '#19ffe0',
              fontSize: 22,
              fontWeight: 'bold',
              fontFamily: 'Arial, sans-serif'
            },
            // 设备数量文字模块
            subtextStyle: {
              fontSize: 16,
              color: '#ff9d19',
              fontWeight: 'normal',
              margin: [0, 5, 0, 0]
            },
            textVerticalAlign: 'middle'
          },
          grid: {
            top: '10%',
            bottom: '10%',
            left: '10%',
            right: '10%',
            containLabel: true
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}<br/> {c}台  ({d}%)',
            textStyle: {
              fontSize: 13,
              color: '#fff'
            },
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            borderColor: 'rgba(25, 255, 224, 0.5)',
            borderWidth: 1,
            padding: [10, 15]
          },
          // 图例配置
          legend: {
            show: this.showLegend,
            orient: 'vertical',
            right: '5%',
            top: 'center',
            itemWidth: 14,
            itemHeight: 10,
            itemGap: 12,
            textStyle: {
              color: '#f2f2f2',
              fontSize: 13,
              fontWeight: 'normal'
            },
            icon: 'roundRect',
            data: this.data,
          },
          series: [
            // 主要展示层的饼图
            { 
              radius: ['50%', '80%'], 
              center: ['45%', '50%'],
              type: 'pie',
              avoidLabelOverlap: true,
              label: {
                position: 'inner',
                formatter: '{b}\n{c}台',
                color: this.fontColor,
                fontSize: 11,
                fontWeight: 'bold',
                lineHeight: 16
              },
              labelLine: {
                show: false
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 13,
                  fontWeight: 'bold'
                },
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              data: this.data,
            },
            // 边框的设置
            {
              radius: ['30%', '35%'],
              center: ['45%', '50%'],
              type: 'pie',
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              animation: false,
              tooltip: {
                show: false
              },
              data: [{
                value: 1,
                itemStyle: {
                  color: "rgba(25, 255, 224, 0.2)",
                },
              }],
            }, 
            // {
            //   name: '外边框',
            //   type: 'pie',
            //   clockWise: false,
            //   hoverAnimation: false,
            //   center: ['45%', '50%'],
            //   radius: ['75%', '70%'],
            //   label: {
            //     show: false
            //   },
            //   data: [{
            //     value: 9,
            //     name: '',
            //     itemStyle: {
            //       borderWidth: 2,
            //       borderColor: 'rgba(25, 255, 224, 0.4)'
            //     }
            //   }]
            // }
          ]
        }
      }
    },
    mounted() {
      this.initChart()
      window.addEventListener('resize', this.handleResize)
      // 调用接口获取数据
      this.fetchData()
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
      if (this.myChart) {
        this.myChart.dispose()
      }
    },
    methods: {
      // 获取接口数据
      async fetchData() {
        try {
             // 获取 token
             const token = this.$store.state.print.goodsForeNo?.token || sessionStorage.getItem('token')
          // 构建请求参数
          const params = {
            token: token
          }
          const res = await left1Data(params)
          // 根据接口返回的数据结构处理数据
          console.log('完整响应:', res)
          console.log('res.data:', res.data)
          console.log('res.data.data:', res.data?.data)
          
          // 获取实际数据，可能是 res.data.data 或 res.data
          let responseData = null
          if (res && res.data) {
            // 如果响应格式是 { status: 'success', data: {...} }
            if (res.data.status === 'success' && res.data.data) {
              responseData = res.data.data
            } 
            // 如果响应格式是 { status: 200, data: {...} }
            else if (res.data.status === 200 && res.data.data) {
              responseData = res.data.data
            }
            // 如果数据直接在 res.data 中
            else if (res.data.device_online !== undefined || res.data.device_offline !== undefined) {
              responseData = res.data
            }
          }
          
          console.log('处理后的数据:', responseData)
          
          // 处理数据
          if (responseData) {
            // 如果是对象格式，包含 device_online 和 device_offline 字段
            if (responseData.device_online !== undefined || responseData.device_offline !== undefined) {
              this.data = [
                { name: '在线设备', value: responseData.device_online || 0 },
                { name: '离线设备', value: responseData.device_offline || 0 }
              ]
              console.log('设置的数据:', this.data)
            }
            // 如果是数组格式
            else if (Array.isArray(responseData)) {
              this.data = responseData.map(item => {
                return {
                  name: item.name || item.label || item.type || '设备',
                  value: item.device_online || item.device_offline || item.value || item.count || item.num || 0
                }
              })
            }
            // 兼容其他可能的字段名
            else if (responseData.online !== undefined || responseData.offline !== undefined) {
              this.data = [
                { name: '在线设备', value: responseData.online || responseData.onlineCount || 0 },
                { name: '离线设备', value: responseData.offline || responseData.offlineCount || 0 }
              ]
            }
            
            // 更新图表
            this.$nextTick(() => {
              if (this.myChart) {
                this.myChart.setOption(this.chartOption)
              }
            })
          }
        } catch (error) {
          console.error('获取设备统计数据失败:', error)
          // 接口失败时使用默认数据
        }
      },
      initChart() {
        this.myChart = echarts.init(this.$refs.chart)
        this.myChart.setOption(this.chartOption)
        
        // 添加事件监听
        this.addEventListeners()
      },
      handleResize() {
        if (this.myChart) {
          this.myChart.resize()
        }
      },
      addEventListeners() {
        // 添加点击事件
        this.myChart.on('click', (params) => {
          this.$emit('chart-click', params)
          console.log('点击了:', params.name, params.value)
        })
        
        // 添加鼠标悬停事件
        this.myChart.on('mouseover', (params) => {
          this.$emit('chart-mouseover', params)
        })
        
        // 添加鼠标离开事件
        this.myChart.on('mouseout', (params) => {
          this.$emit('chart-mouseout', params)
        })
      },
      updateData() {
        // 模拟数据更新
        this.data = this.data.map(item => {
          const change = Math.floor(Math.random() * 100) - 30
          const newValue = Math.max(10, item.value + change)
          return {
            ...item,
            value: newValue
          }
        })
        
        this.$nextTick(() => {
          this.myChart.setOption(this.chartOption)
        })
      },
      resetData() {
        this.data = [
          { name: "中央", value: 456 },
          { name: "自治区", value: 231 },
          { name: "盟市", value: 121 },
          { name: "旗县区", value: 45 },
          { name: "整合资金", value: 154 },
          { name: "其他", value: 67 }
        ]
        
        this.$nextTick(() => {
          this.myChart.setOption(this.chartOption)
        })
      },
      toggleLegend() {
        this.showLegend = !this.showLegend
        this.$nextTick(() => {
          this.myChart.setOption(this.chartOption)
        })
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .header {
    height: 10%;
    text-align: center;
    // margin-bottom: 40px;
    // padding: 20px;
    
    h1 {
      font-size: 20px;
      margin-bottom: 8px;
      background: linear-gradient(90deg, #bf19ff, #02cdff);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
    
    p {
      color: #8ca0d7;
      font-size: 16px;
      max-width: 600px;
      margin: 0 auto;
      line-height: 1.6;
    }
  }
  .containeraa{
    height: 100%;
    display: flex;
    .left1-container{
      width: 50%;
      height: 100%;
      // border: 1px solid #000000;
    }
    .right1-container{
      width: 50%;
      height: 100%;
      // border: 1px solid #000000;
    }
  }
  .chart-container {
    height: 80%;
    display: flex;
    justify-content: center;
    // margin-bottom: 40px;
  }
  
  .chart-wrapper {
    width: 100%;
    max-width: 1000px;
    height: 100%;
    // background: rgba(16, 33, 77, 0.3);
    border-radius: 12px;
    // box-shadow: 0 10px 30px rgba(0, 20, 80, 0.4);
    // padding: 20px;、
    // border: 1px solid rgba(64, 128, 255, 0.2);
  }
  
  .data-info {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 20px;
  }
  
  .data-item {
    // background: rgba(20, 40, 80, 0.5);
    // padding: 12px 20px;
    // border-radius: 8px;
    font-size: 12px;
    display: flex;
    align-items: center;
    // border: 1px solid rgba(100, 150, 255, 0.2);
  }
  
  .color-indicator {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 10px;
  }
  
  .controls {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
  }
  
  .control-btn {
    // background: rgba(30, 60, 120, 0.7);
    // border: 1px solid rgba(100, 150, 255, 0.3);
    color: #b3ccf8;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    
    &:hover {
    //   background: rgba(50, 100, 200, 0.7);
      transform: translateY(-2px);
    //   box-shadow: 0 5px 15px rgba(0, 50, 150, 0.3);
    }
  }
  
  @media (max-width: 768px) {
    .chart-wrapper {
      height: 500px;
      padding: 15px;
    }
    
    .header h1 {
      font-size: 26px;
    }
    
    .data-item {
      font-size: 14px;
      padding: 10px 15px;
    }
    
    .controls {
      flex-direction: column;
      align-items: center;
    }
    
    .control-btn {
      width: 80%;
    }
  }
  </style>